import { get, post } from '../../helpers/axiosWrapper';

export const getSmartMeterConsentGridData = async (
  url: string | undefined,
  context: any,
  customerAccountReference: string
): Promise<Common.IResult<Array<Api.ISmartMeterConsent>>> => {
  const headers: Api.ISmartMeterConsentGridParams = {
    customerAccountReference: customerAccountReference,
  };

  const apiUrl = 'consumption/consent-by-customer-account-reference';

  return await get(`${url}/${apiUrl}`, { headers }, context);
};

export const getSmartMeterConsentExcludingNoConsent = async (
  url: string | undefined,
  context: any,
  customerAccountReference: string
): Promise<Common.IResult<Array<Api.ISmartMeterConsentDownloadHh>>> => {
  const headers: Api.ISmartMeterConsentGridParams = {
    customerAccountReference: customerAccountReference,
  };

  const apiUrl = 'consumption/download-hh-consent-by-customer-account-reference';

  return await get(`${url}/${apiUrl}`, { headers }, context);
};

export const giveConsent = async (
  url: string | undefined,
  context: any,
  essCustomerId: string,
  tcId: string,
  reference: string,
  mpans: Array<number>
): Promise<Common.IResult<boolean>> => {
  const data: Api.IUpdateConsentParams = {
    customerAccountReference: essCustomerId,
    mpans: mpans,
    consent: true,
    termsAndConditionsId: tcId,
    termsAndConditionsReference: reference,
  };

  const apiUrl = 'consumption/update-consent';

  return await post(`${url}/${apiUrl}`, { data }, context);
};

export const refuseConsent = async (
  url: string | undefined,
  context: any,
  essCustomerId: string,
  mpans: Array<number>
): Promise<any> => {
  const data: Api.IRefuseConsentParams = {
    customerAccountReference: essCustomerId,
    mpans: mpans,
    consent: false,
  };

  const apiUrl = 'consumption/update-consent';

  return await post(`${url}/${apiUrl}`, { data }, context);
};
